"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

var _lodash = _interopRequireDefault(require("lodash"));

require("whatwg-fetch");

var _baseForm = _interopRequireDefault(require("./../base-form"));

var _modal = _interopRequireDefault(require("../modal"));

var _formInputs = require("../form-inputs");

var _authorisation = _interopRequireDefault(require("../authorisation"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _conf = _interopRequireDefault(require("../../conf"));

var _translate = _interopRequireDefault(require("./../translate"));

var _button = _interopRequireDefault(require("./lib/button"));

var _datamasterForms = require("datamaster-forms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var UpdateUsernameAuthorized = new _authorisation.default(['admin'], [], false)(_button.default);

var emptyForm = function emptyForm() {
  return {
    error: null,
    invalidFields: {
      fields: [],
      details: {}
    },
    success: false
  };
};

var createError = function createError(form) {
  return function (error, fields, details) {
    var state = {};
    state[form] = {
      isEditable: true,
      error: error,
      invalidFields: {
        fields: fields,
        details: details
      },
      success: false
    };
    return state;
  };
};

var User = /*#__PURE__*/function (_BaseForm) {
  _inherits(User, _BaseForm);

  function User(props) {
    var _this;

    _classCallCheck(this, User);

    _this = _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).call(this, props));
    _this.state = _lodash.default.extend(_this.state, {
      user: {
        id: null,
        username: '',
        salutation: {
          name: ''
        },
        last_name: '',
        first_name: '',
        address: '',
        zip: '',
        city: '',
        telephone: '',
        email: '',
        user_has_no_email: '',
        comments: '',
        password: '',
        password_repeat: '',
        project_interests: []
      },
      projects: [],
      salutationList: [],
      verified: false,
      resetPasswordModalOpen: false,
      resetUsernameModalOpen: false,
      password: '',
      resetPasswordForm: emptyForm(),
      username: '',
      resetUsernameForm: emptyForm()
    });

    if (props.user) {
      _this.state.user = props.user;
      _this.state.username = props.user.username;
    }

    _this.resetPasswordModalRef = _react.default.createRef();
    _this.resetUsernameModalRef = _react.default.createRef();
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleResetPasswordChange = _this.handleResetPasswordChange.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.handleResetPasswordSubmit = _this.handleResetPasswordSubmit.bind(_assertThisInitialized(_this));
    _this.handleResetUsernameSubmit = _this.handleResetUsernameSubmit.bind(_assertThisInitialized(_this));
    _this.handleInputChangeMultiSelect = _this.handleInputChangeMultiSelect.bind(_assertThisInitialized(_this));
    _this.topMessage = _this.topMessage.bind(_assertThisInitialized(_this));
    _this.resetPasswordMessage = _this.resetPasswordMessage.bind(_assertThisInitialized(_this));
    _this.showFormButtons = _this.showFormButtons.bind(_assertThisInitialized(_this));
    _this.setStateProperty = _this.setStateProperty.bind(_assertThisInitialized(_this));
    _this.openResetPasswordModal = _this.openResetPasswordModal.bind(_assertThisInitialized(_this));
    _this.closeResetPasswordModal = _this.closeResetPasswordModal.bind(_assertThisInitialized(_this));
    _this.resetResetPasswordModal = _this.resetResetPasswordModal.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(User, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // if on project page, get user according to farm ID
      if (this.props.farmId) {
        fetch(_conf.default.api.userFromFarmApiUrlTemplate(this.props.i18n.language, this.props.farmId), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (user) {
          _this2.setState(function (prev) {
            prev.user = user;
            return prev;
          });

          return fetch(_conf.default.api.userEmailVerifiedApiUrlTemplate(_this2.props.i18n.language, _this2.state.user.id), {
            credentials: 'include'
          });
        }).then(_fetchUtils.default.checkStatus).then(function (response) {
          if (response.verified) {
            _this2.setState(function (prev) {
              prev.verified = response.verified;
              return prev;
            });
          }
        }).catch(function (err) {
          _this2.setState(function (prev) {
            prev.form.error = err.message;
            return prev;
          });
        });
      } else {
        fetch(_conf.default.api.userEmailVerifiedApiUrlTemplate(this.props.i18n.language, this.state.user.id), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (response) {
          if (response.verified) {
            _this2.setState(function (prev) {
              prev.verified = response.verified;
              return prev;
            });
          }
        }).catch(function (err) {
          _this2.setState(function (prev) {
            prev.form.error = err.message;
            return prev;
          });
        });
      }

      fetch("".concat(_conf.default.api.allProjects(this.props.i18n.language)), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (projects) {
        _this2.setState(function (prev) {
          prev.projects = projects;
          return prev;
        });
      }).catch(function (err) {
        void 0;

        if (err.error.status === 404) {
          _this2.props.history.push('/not-found');
        }
      });
      fetch(_conf.default.api.salutationApiUrlTemplate(this.props.i18n.language), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (response) {
        _this2.setState(function (prev) {
          prev.salutationList = response.map(function (entry) {
            entry.id = parseInt(entry.id);
            return entry;
          });
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (!prevProps.user && !this.props.user) return;

      if (prevProps.user.id !== this.props.user.id) {
        this.setState(function (prev) {
          prev.username = _this3.props.user.username;
          return prev;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var t = this.props.t;

      var closeUsernameModal = function closeUsernameModal() {
        return _this4.closeResetPasswordModal('resetUsernameModalOpen', 'username', 'resetUsernameForm', _this4.state.user.username);
      };

      var closePasswordModal = function closePasswordModal() {
        return _this4.closeResetPasswordModal('resetPasswordModalOpen', 'password', 'resetPasswordForm');
      };

      return /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.anchorId || '',
        className: "comp-base-form"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement(UpdateUsernameAuthorized, {
        onClick: function onClick() {
          return _this4.openResetPasswordModal('resetUsernameModalOpen');
        },
        text: t('reset username')
      })), /*#__PURE__*/_react.default.createElement("h2", {
        id: "User",
        className: "form-title"
      }, t('User')), this.topMessage(), /*#__PURE__*/_react.default.createElement(_datamasterForms.ProfileForm, {
        submitSectionContact: this.handleSubmit,
        submitSectionPassword: this.handleSubmit,
        submitSectionInterests: this.handleSubmit,
        InputField: _formInputs.AdapterText,
        InputSelect: _formInputs.AdapterSelect,
        InputTelephone: _formInputs.TelephoneInput,
        InputCheckbox: _formInputs.CheckboxInput,
        MultiSelectText: _formInputs.AdapterMultiSelect,
        salutationOptions: this.state.salutationList,
        allProjects: this.state.projects,
        t: t,
        user: this.state.user,
        texts: {
          sectionContact: {
            accordionTitle: t('datamaster-forms:::farm-section-contact'),
            username: t('username'),
            salutation: t('datamaster-forms:::general-salutation'),
            firstName: t('datamaster-forms:::general-first-name'),
            lastName: t('datamaster-forms:::general-last-name'),
            address: t('datamaster-forms:::general-street'),
            zip: t('datamaster-forms:::general-zip'),
            city: t('datamaster-forms:::general-city'),
            telephone: t('datamaster-forms:::general-phone'),
            email: t('datamaster-forms:::general-email-address'),
            userHasNoEmail: t('datamaster-forms:::general-no-email'),
            submit: t('datamaster-forms:::general-save'),
            pleaseChoose: ''
          },
          sectionPassword: {
            accordionTitle: t('reset password'),
            password: t('datamaster-forms:::general-password'),
            passwordConfirm: t('datamaster-forms:::general-password-repeat'),
            submit: t('datamaster-forms:::general-save')
          },
          sectionInterests: {
            accordionTitle: t('datamaster-forms:::general-interests'),
            projectInterests: t('datamaster-forms:::general-project-interests'),
            submit: t('datamaster-forms:::general-save')
          }
        },
        error: {
          contact: this.state.form.error,
          password: this.state.form.error,
          interests: this.state.form.error
        },
        invalidFields: this.state.form.invalidFields,
        isSaving: {
          contact: this.state.isSaving,
          password: this.state.isSaving,
          interests: this.state.isSaving
        },
        success: {
          contact: this.state.form.success,
          password: this.state.form.success,
          interests: this.state.form.success
        },
        handleInputChange: this.handleInputChange,
        handleInputMultiSelectChange: this.handleInputChangeMultiSelect,
        progressContact: false
      }), /*#__PURE__*/_react.default.createElement(_modal.default, {
        ref: this.resetPasswordModalRef,
        id: "reset-password",
        classes: [this.state.isSaving ? 'is-saving' : ''].join(' '),
        isOpen: this.state.resetPasswordModalOpen,
        closeHandler: closePasswordModal,
        backgroundClickClose: true,
        escClose: true
      }, /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement("h2", null, t('Edit user')), this.resetPasswordMessage(this.state.resetPasswordForm.error, this.state.resetPasswordForm.success), /*#__PURE__*/_react.default.createElement("div", {
        className: "space-2"
      }, /*#__PURE__*/_react.default.createElement(_formInputs.TextInput, {
        t: t,
        name: "password",
        value: this.state.password,
        label: t('reset password'),
        onChange: this.handleResetPasswordChange,
        errors: this.state.resetPasswordForm.invalidFields.details
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: this.handleResetPasswordSubmit,
        className: "btn"
      }, t('save')), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--secondary",
        type: "button",
        onClick: closePasswordModal
      }, t('cancel'))))))), /*#__PURE__*/_react.default.createElement(_modal.default, {
        ref: this.resetUsernameModalRef,
        id: "reset-username",
        classes: [this.state.isSaving ? 'is-saving' : ''].join(' '),
        isOpen: this.state.resetUsernameModalOpen,
        closeHandler: closeUsernameModal,
        backgroundClickClose: true,
        escClose: true
      }, /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement("h2", null, t('Edit user')), this.resetPasswordMessage(this.state.resetUsernameForm.error, this.state.resetUsernameForm.success), /*#__PURE__*/_react.default.createElement("div", {
        className: "space-2"
      }, /*#__PURE__*/_react.default.createElement(_formInputs.TextInput, {
        t: t,
        name: "username",
        value: this.state.username,
        label: t('reset username'),
        onChange: this.handleResetPasswordChange,
        errors: this.state.resetUsernameForm.invalidFields.details
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: this.handleResetUsernameSubmit,
        className: "btn"
      }, t('save')), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--secondary",
        type: "button",
        onClick: closeUsernameModal
      }, t('cancel'))))))));
    }
    /**
     *
     * @param event
     */

  }, {
    key: "handleResetPasswordChange",
    value: function handleResetPasswordChange(event) {
      var target = event.target;
      var name = target.name;
      var value = target.value;
      this.setState(function (prevState) {
        prevState[name] = value;
        return prevState;
      });
    }
    /**
     *
     * @param name
     * @param value
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(name, value) {
      if (name === 'salutation') {
        value = this.state.salutationList.find(function (salutation) {
          return parseInt(salutation.id) === parseInt(value);
        });
      }

      this.setState(function (prevState) {
        prevState.user[name] = value;
        return prevState;
      });
    }
    /**
     *
     */

  }, {
    key: "handleInputChangeMultiSelect",
    value: function handleInputChangeMultiSelect(fieldName, elements) {
      this.setState(function (prev) {
        prev.user.project_interests = elements.map(function (element) {
          return prev.projects.find(function (project) {
            return parseInt(project.id) === element;
          });
        });
        return prev;
      });
    }
    /**
     *
     * @param event
     */

  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this5 = this;

      event.preventDefault();

      if (!this.state.user.id) {
        return void 0;
      }

      var user = _lodash.default.clone(this.state.user);

      delete user.id;
      delete user.username;
      if (!user.password) delete user.password;
      if (!user.password_repeat) delete user.password_repeat;
      this.setState({
        isSaving: true
      });
      fetch("".concat(_conf.default.api.userApiUrlTemplate(this.props.i18n.language), "/").concat(this.state.user.id), {
        method: 'PUT',
        body: JSON.stringify(user),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (updatedUser) {
        _this5.setState(function (prev) {
          var emailVerified = prev.verified;
          prev.user = updatedUser;
          prev.verified = emailVerified;
          prev.form = {
            error: null,
            isEditable: false,
            invalidFields: {
              fields: [],
              details: {}
            },
            success: true
          };
          prev.isSaving = false;
          return prev;
        });

        setTimeout(function () {
          _this5.setState(function (prev) {
            prev.form.success = false;
            return prev;
          });
        }, 5000);
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this5.setState(function (prev) {
          prev.form = {
            isEditable: true,
            error: message,
            invalidFields: {
              fields: Object.keys(invalidFields),
              details: invalidFields
            },
            success: false
          };
          prev.isSaving = false;
          return prev;
        });

        _this5.editModalRef.current.scrollToTop();
      });
    }
  }, {
    key: "handleResetPasswordSubmit",
    value: function handleResetPasswordSubmit(event) {
      var _this6 = this;

      event.preventDefault();
      var error = createError('resetPasswordForm');

      if (!this.state.password) {
        this.setState(error('', ['password'], {
          password: ['required']
        }));
        return;
      }

      var body = {
        password: this.state.password,
        password_repeat: this.state.password
      };
      this.setState({
        isSaving: true
      });
      fetch("".concat(_conf.default.api.userApiUrlTemplate(this.props.i18n.language), "/").concat(this.state.user.id), {
        method: 'PUT',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function () {
        _this6.setState(function (prev) {
          prev.password = '';
          prev.resetPasswordForm = emptyForm();
          prev.isSaving = false;
          return prev;
        });

        setTimeout(function () {
          _this6.setState(function (prev) {
            prev.resetPasswordForm.success = false;
            prev.resetPasswordModalOpen = false;
            return prev;
          });
        }, 1000);
      }).catch(function (err) {
        var message = err.message;
        var invalidFields = {};

        if (err.status === 422) {
          invalidFields = _lodash.default.get(err, 'details.codes');
        }

        _this6.setState(function (prev) {
          _this6.setState(error(message, Object.keys(invalidFields), invalidFields));

          prev.isSaving = false;
          return prev;
        });
      });
    }
  }, {
    key: "handleResetUsernameSubmit",
    value: function handleResetUsernameSubmit(event) {
      var _this7 = this;

      event.preventDefault();
      var error = createError('resetUsernameForm');

      if (!this.state.username) {
        this.setState(error('', ['username'], {
          username: ['required']
        }));
        return;
      }

      var body = {
        username: this.state.username
      };
      this.setState({
        isSaving: true
      });
      fetch("".concat(_conf.default.api.updateUserName(this.props.i18n.language, this.state.user.id)), {
        method: 'PUT',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (response) {
        _this7.setState(function (prev) {
          prev.username = response.username;
          prev.resetUsernameForm = emptyForm();
          prev.isSaving = false;
          return prev;
        });

        setTimeout(function () {
          _this7.setState(function (prev) {
            prev.resetUsernameForm.success = false;
            prev.resetUsernameModalOpen = false;
            prev.user = response;
            return prev;
          });
        }, 1000);
      }).catch(function (err) {
        var message = error.message;
        var invalidFields = {};

        if (err.status === 422) {
          invalidFields = _lodash.default.get(err, 'details.codes');
        }

        _this7.setState(function (prev) {
          _this7.setState(error(message, Object.keys(invalidFields), invalidFields));

          prev.isSaving = false;
          return prev;
        });
      });
    }
  }, {
    key: "openResetPasswordModal",
    value: function openResetPasswordModal(property) {
      this.setState(function (prev) {
        prev[property] = true;
        return prev;
      });
    }
  }, {
    key: "closeResetPasswordModal",
    value: function closeResetPasswordModal(modalProperty, property, form, defaultValue) {
      this.setState(function (prev) {
        prev[modalProperty] = false;
        return prev;
      });
      this.resetResetPasswordModal(property, form, defaultValue);
    }
  }, {
    key: "resetResetPasswordModal",
    value: function resetResetPasswordModal(property, form, defaultValue) {
      this.setState(function (prev) {
        prev[property] = defaultValue;
        prev[form] = emptyForm();
        return prev;
      });

      _get(User.prototype.__proto__ || Object.getPrototypeOf(User.prototype), "resetEditMode", this).call(this);
    }
  }, {
    key: "resetPasswordMessage",
    value: function resetPasswordMessage(error, success) {
      var t = this.props.t;
      if (error) return /*#__PURE__*/_react.default.createElement("div", {
        "data-abide-error": true,
        role: "alert",
        className: "alert callout"
      }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("i", {
        className: "fi-warning"
      }), t(error)));else if (success) return /*#__PURE__*/_react.default.createElement("div", {
        className: "success callout",
        "data-closable": "slide-out-right"
      }, /*#__PURE__*/_react.default.createElement("p", null, t('Record saved successfully')));
    }
  }]);

  return User;
}(_baseForm.default);

User.defaultProps = {
  anchorId: 'user-data'
};
User.propTypes = {
  anchorId: _propTypes.default.string
};

var _default = (0, _translate.default)(User);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/user/user.js
// module id = 54
// module chunks = 0